<section class="aarni-font w-full shadow border-b mt-[80px] py-[50px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>
    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 md:max-h-screen md:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">B.Tech ECE Specialisations</h2>
                    <div class="">
                        <a
                            [href]="'schools/arni-school-of-technology/btech-ece/chip-designing'"
                            [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech ECE (VLSI) in Chip Designing', 'text-blue-600 bg-white' : pageTitle !== 'BTech ECE (VLSI) in Chip Designing'}"
                            class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Chip Designing</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow  hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                              <span
                                  class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium   md:text-[16px] xl:text-xl ">Faculty</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Testimonials</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                               <span
                                   class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                                    <i class="fa fa-phone text-2xl"></i>
                              </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Leadership</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="md:p-12 shadow-lg border-gray-200 bg-white h-fit ">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'BTech ECE (VLSI) in Chip Designing'">
                    <p class="text-gray-500 text-justify my-3">The demand for compact, efficient, and high-performance
                        electronic devices is increasing drastically, and to run appliances, Chip plays an important
                        role as it is considered the heart of these devices. ARNI University's B.Tech in Electronics and
                        Communication Engineering with a specialization in VLSI Chip Designing offers a meticulously
                        crafted curriculum that bridges theoretical knowledge with practical application.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">The B.Tech ECE (VLSI) in Chip Designing program is a
                        four-year curriculum that is intended to equip engineering graduates with a comprehensive
                        understanding of integrated circuit designs, which are commonly referred to as "chip design."
                        The course aims to develop competent graduates who understand the fundamentals of VLSI design,
                        which is necessary in industries related to VLSI.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">VLSI is a technique of integrating thousands or even
                        millions of transistors into a single chip to create integrated circuits (ICs). Applications for
                        VLSI chips are numerous and include computers, mobile phones, medical equipment, automotive
                        systems, and more.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">Through our comprehensive curriculum, students can learn
                        about semiconductor technology, system-on-chip (SoC) architectures, and analog or digital
                        circuit designs, along with hands-on training using industry-standard tools and software,
                        ensuring graduates are well-equipped to tackle real-world challenges. This specialization equips
                        engineers with expertise in creating complex electronic circuits, often found in devices like
                        smartphones, computers, and more.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">
                        ARNI University stands out with its commitment to excellence in education and research. The
                        institution boasts advanced laboratories and strong industry collaborations, ensuring students
                        receive a comprehensive and contemporary education. Our faculty is formed with seasoned
                        educators and business experts, making sure that students understand the principles of
                        electrical communication as well as the intricacies of developing state-of-the-art VLSI chips.
                    </p>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Course Objectives
                    </h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>To provide a comprehensive understanding of the VLSI chip system that equips students with
                            a solid foundation of its principles, encompassing both digital and analog design
                            methodologies.
                        </li>
                        <li>To train students with proficiency in designing tools and software, providing hands-on
                            experience with EDA tools, including Cadence & Synopsys, ensuring accomplishment of both
                            theoretical concepts and practical implementations.
                        </li>
                        <li>Introducing students to the SoC infrastructure enables them to design and integrate multiple
                            functionalities into a single chip, which is a highly valuable skill in modern electronics.
                        </li>
                        <li>To teach power consumption and optimizing strategies to enhance speed in chip designs,
                            addressing the critical requirements of contemporary electronic devices.
                        </li>
                        <li>Foster communication, teamwork, and ethical considerations, ensuring graduates are not only
                            technically proficient but also well-rounded professionals.
                        </li>
                        <li>Incorporate modules on Design for Testability (DFT) and verification techniques to ensure
                            reliability and functionality of VLSI designs before fabrication.
                        </li>

                    </ul>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Scope
                    </h3>
                    <p class="text-gray-500 my-3">
                        The rapidly growing demand in the global semiconductor industry is projected to surpass USD 1
                        trillion by 2030. Following this, the demand for skilled professionals will increase across the
                        world. Economically strong countries like the USA, South Korea, Taiwan, and India are investing
                        heavily in chip manufacturing and design.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>“Make in India” and “Semicon India” initiatives are boosting chip manufacturing and
                            designing in the country. This course of action aligns with national growth and provides
                            direct employment opportunities in India.
                        </li>
                        <li>Major MNC companies like AMD, Intel, Qualcomm, Texas, TSMC, and other Indian startups are
                            constantly hiring VLSI engineers. The degree holders can secure roles in both emerging
                            startups and established firms.
                        </li>
                        <li>Graduates can pursue Master’s or Ph.D. programs in VLSI and Microelectronics from top
                            universities worldwide. There is ample funding and scholarship support in countries like the
                            USA, Germany, and Canada for advanced research.
                        </li>
                        <li>Chip design is at the core of technologies like Artificial Intelligence, Internet of Things
                            (IoT), robotics, and automotive electronics. This opens interdisciplinary job roles such as
                            VLSI Design Engineer, Physical Design Engineer, Analog and Mixed-Signal Design Engineer,
                            Research and Development Specialist, and FPGA Developer that are future-proof and
                            high-paying.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">ARNI University's B.Tech program offers comprehensive electronics and
                        communication systems knowledge, focusing on VLSI Chip Design, preparing graduates for industry
                        demands and shaping the future of communication engineering.
                    </p>
                </div>
            </div>
        </div>
    </div>

</section>
